'use strict';

/*global blockElement*/
/*global unBlockElement*/
/*global isEmpty*/
/*global services*/
function RegistrationProducts($container) {
    this.$container = $container;

    this.$priceDefinition = null;

    this.init();
}

RegistrationProducts.prototype = $.extend({}, {
    construtor: 'RegistrationProducts',

    //**************************************************************************

    registerCallbacks: function registerCallbacks() {
        var _this = this;

        _this.$container.on('change', '.price-definition__product-group--table tfoot input', function () {
            _this.addProductGroup();
        });

        _this.$container.on('change', '.price-definition__product-group--table tbody input', function () {
            _this.editProductGroup();
        });

        _this.$container.on('change', '.form-block__options[data-block="template"] input:radio', function () {
            _this.updatePriceDefinitionTable();
        });

        _this.$container.on('change', '.form-block__options[data-block="interval"] input:radio', function () {
            _this.updatePriceDefinitionTable();
        });

        _this.$container.on('change', '.price-definition__interval--hours-input', function () {
            _this.updatePriceDefinitionTable();
        });

        _this.$container.on('change', '.form-block__options[data-block="additional_hours"] input:radio', function () {
            _this.updatePriceDefinitionTable();
        });

        _this.$container.on('change', '.form-block__options[data-block="interval-all-windows"] input:radio', function () {
            _this.updatePriceDefinitionTable();
        });

        _this.$container.on('change', '.form-block__options[data-block="product-groups"] input:radio', function () {
            _this.updatePriceDefinitionTable();
        });

        _this.$container.on('change', '.form-block__options[data-block="guarantee_price"] input:radio', function () {
            _this.updatePriceDefinitionTable();
        });

        _this.$container.on('click', '.price-definition__product-group--add', function () {
            _this.$container.find('.price-definition__product-group--table tfoot input').focus();

            return false;
        });

        return _this;
    },

    //**************************************************************************

    addProductGroup: function addProductGroup() {
        var _this = this;

        var $productGroupTable = _this.$container.find('.price-definition__product-group--table');
        var $productGroupNewRow = $productGroupTable.find('tfoot tr');
        var productGroup = $productGroupNewRow.find('input').val();
        if (!isEmpty(productGroup)) {
            var $productGroupRow = $productGroupTable.find('tbody tr:last').clone();
            $productGroupRow.find('input').val(productGroup);
            $productGroupTable.find('tbody').append($productGroupRow);

            $productGroupNewRow.find('input').val('');

            _this.updatePriceProductGroup();
        }

        return _this;
    },

    editProductGroup: function editProductGroup() {
        var _this = this;

        _this.updatePriceProductGroup();

        return _this;
    },

    updatePriceTemplate: function updatePriceTemplate() {
        var _this = this;

        var isVisible = _this.$container.find('.form-block__options[data-block="template"] :radio:checked').val() === '1';
        var $templateMorning = _this.$priceDefinition.find('.price-definition__template-morning');
        var $templateAfternoon = _this.$priceDefinition.find('.price-definition__template-afternoon');
        if (isVisible) {
            $templateMorning.show();
            $templateAfternoon.show();
        } else {
            $templateMorning.hide();
            $templateAfternoon.hide();
        }

        return isVisible;
    },

    updatePriceInterval: function updatePriceInterval() {
        var _this = this;

        var isVisible = _this.$container.find('.form-block__options[data-block="interval"] :radio:checked').val() === '1';
        var $intervals = _this.$priceDefinition.find('.price-definition__interval');
        if (isVisible) {
            $intervals.show();
        } else {
            $intervals.hide();
        }

        var hours = _this.$container.find('.price-definition__interval--hours-input').val();
        if (isEmpty(hours)) {
            hours = 1;
        }

        _this.$priceDefinition.find('.price-definition__interval--hours').text(hours);

        return isVisible;
    },

    updatePriceAdditionalHours: function updatePriceAdditionalHours() {
        var _this = this;

        var isVisible = _this.$container.find('.form-block__options[data-block="additional_hours"] :radio:checked').val() === '1';
        var $additionalHours = _this.$priceDefinition.find('.price-definition__interval-additional-hour');
        if (isVisible) {
            $additionalHours.show();
        } else {
            $additionalHours.hide();
        }

        return isVisible;
    },

    updatePriceIntervalAllWindows: function updatePriceIntervalAllWindows() {
        var _this = this;

        var isVisible = _this.$container.find('.form-block__options[data-block="interval-all-windows"] :radio:checked').val() === '1';
        var $allWindows = _this.$priceDefinition.find('.price-definition__interval-all-windows');
        if (isVisible) {
            $allWindows.show();
        } else {
            $allWindows.hide();
        }

        return isVisible;
    },

    updatePriceProductGroup: function updatePriceProductGroup() {
        var _this = this;

        var isVisible = _this.$container.find('.form-block__options[data-block="product-groups"] :radio:checked').val() === '1';
        var $productGroup = _this.$priceDefinition.find('.price-definition__product-group');
        var $addProductGroup = _this.$container.find('.price-definition__product-group--add').hide();
        if (isVisible) {
            $productGroup.show();
            $addProductGroup.show();

            _this.$priceDefinition.find('tbody tr').show();
        } else {
            $productGroup.hide();
            $addProductGroup.hide();
            _this.$priceDefinition.find('tbody tr:not(:first)').hide();
        }   

        if (isVisible) {
            var $productGroupTable = _this.$container.find('.price-definition__product-group--table');
            var $priceDefinitionTable = _this.$container.find('.price-definition__table');

            $productGroupTable.find('tbody tr').each(function () {
                var $productGroupRow = $(this);
                var $priceDefinitionRow = $priceDefinitionTable.find('tbody tr:eq(' + $productGroupRow.index() + ')');

                if (!$priceDefinitionRow.length) {
                    $priceDefinitionRow = $priceDefinitionTable.find('tbody tr:last').clone();
                    $priceDefinitionRow.find('input:text').val('');
                    $priceDefinitionTable.find('tbody').append($priceDefinitionRow);
                }

                $priceDefinitionRow.find('.price-definition__product-group').text($productGroupRow.find('input').val());
            });
        }

        return isVisible;
    },

    updatePriceGuaranteePrice: function updatePriceGuaranteePrice() {
        var _this = this;

        var isVisible = _this.$container.find('.form-block__options[data-block="guarantee_price"] :radio:checked').val() === '1';
        var $guaranteePrice = _this.$priceDefinition.find('.price-definition__guarantee-price');
        if (isVisible) {
            $guaranteePrice.show();
        } else {
            $guaranteePrice.hide();
        }

        return isVisible;
    },

    updatePriceDefinitionTable: function updatePriceDefinitionTable() {
        var _this = this;

        var isSomethingVisible = false;

        isSomethingVisible = _this.updatePriceTemplate() || isSomethingVisible;
        isSomethingVisible = _this.updatePriceInterval() || isSomethingVisible;
        isSomethingVisible = _this.updatePriceAdditionalHours() || isSomethingVisible;
        isSomethingVisible = _this.updatePriceIntervalAllWindows() || isSomethingVisible;
        isSomethingVisible = _this.updatePriceProductGroup() || isSomethingVisible;
        isSomethingVisible = _this.updatePriceGuaranteePrice() || isSomethingVisible;

        if (isSomethingVisible) {
            _this.$priceDefinition.slideDown();
        } else {
            _this.$priceDefinition.slideUp();
        }

        return _this;
    },

    //**************************************************************************    

    init: function init() {
        var _this = this;
      
        _this.registerCallbacks();
        _this.$priceDefinition = _this.$container.find('.price-definition');
        _this.updatePriceDefinitionTable();

        return _this;
    }
});
